import { createTheme } from '@mui/material/styles';

const theme = createTheme({
	palette: {
		background: {
			default: '#f8a551',//#f8bbd0',
		},
		primary: {
			main: '#80c2c2',//#ab47bc: light purple #ee6e6e: peach #e4cfc2: lighter skin #f8a551: skin light #f79838: skin #80c2c2: lighter blue #00b0ff: light blue #19468b: darker blue #008585: light greenteal #006c6c: dark teal #0d9d59: light green
		},		
		secondary: {
			main: '#19468b'//#ec407a:pink
		},
		error: {
			main: '#e53935',
		},
		warning: {
			main: '#ffa000',//amber shade
		},
		info: {
			main: '#6B7D6A',
		},
		success: {
			main: '#09FE00',
		},
		text: {
			primary: '#000000',
			secondary: '#ee6e6e'//#ec407a:pink
		},
	},
})

export default theme;
